const subjectMatterInput = /[^A-Za-z0-9\s\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\\\:\;\"\'\,\<\.\>\?\/]+/

function getMessage(field, args) {
  return `The ${field} consist of invalid characters.`
}

function validate(value, args) {
  if (value) {
    if (subjectMatterInput.test(value)) {
      return false
    } else {
      return true
    }
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
